/**
 * カード YAML の markdown（インライン記法だけ。card-schema.md §2）を区切る。
 * HTML 文字列は作らない（{@html} を使わないため）。描画は InlineMarkdown.svelte。
 */

export type InlineSegment =
  | { kind: 'text'; text: string }
  | { kind: 'code'; text: string }
  | { kind: 'strong'; text: string }
  | { kind: 'link'; text: string; href: string };

const PATTERN = /`([^`]+)`|\*\*([^*]+)\*\*|\[([^\]]+)\]\(([^)\s]+)\)/g;

export function parseInline(src: string): InlineSegment[] {
  const out: InlineSegment[] = [];
  let last = 0;
  for (const m of src.matchAll(PATTERN)) {
    const at = m.index;
    if (at > last) out.push({ kind: 'text', text: src.slice(last, at) });
    if (m[1] !== undefined) out.push({ kind: 'code', text: m[1] });
    else if (m[2] !== undefined) out.push({ kind: 'strong', text: m[2] });
    else if (m[3] !== undefined && m[4] !== undefined) {
      const href = m[4];
      // 外部への任意の URL は張らない。https と相対パスだけ
      if (/^(https:\/\/|\/|#)/.test(href)) out.push({ kind: 'link', text: m[3], href });
      else out.push({ kind: 'text', text: m[3] });
    }
    last = at + m[0].length;
  }
  if (last < src.length) out.push({ kind: 'text', text: src.slice(last) });
  return out;
}

/** 改行で段落に分ける（空行の有無を問わない） */
export function paragraphs(src: string): string[] {
  return src
    .split(/\n+/)
    .map((s) => s.trim())
    .filter((s) => s !== '');
}
